import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); navigate("/admin"); toast.success("Connexion réussie"); }
    catch (err) { toast.error(err.response?.data?.detail || "Identifiants incorrects"); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f2b4c] font-body" data-testid="admin-login-page">
      <Toaster position="top-right" />
      <div className="w-full max-w-sm px-6">
        <div className="bg-white/[0.07] backdrop-blur-sm border border-white/10 rounded-sm p-8">
          <div className="text-center mb-10">
            <h1 className="font-heading text-3xl mb-2 text-white">OFA<span className="text-sky-400">Lycée</span></h1>
            <p className="text-sm text-white/50">Espace d'administration</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div><Label htmlFor="email" className="text-white/70">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@ofalycee.org" className="border-b border-white/20 bg-transparent px-0 rounded-none focus-visible:ring-0 mt-2 text-white placeholder:text-white/30" required data-testid="login-email" /></div>
            <div><Label htmlFor="password" className="text-white/70">Mot de passe</Label><Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;" className="border-b border-white/20 bg-transparent px-0 rounded-none focus-visible:ring-0 mt-2 text-white placeholder:text-white/30" required data-testid="login-password" /></div>
            <Button type="submit" disabled={loading} className="w-full rounded-none bg-sky-500 hover:bg-sky-600 text-white" data-testid="login-submit">{loading ? "Connexion..." : "Se connecter"}</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
